import { useProductsResponseQueryStateOrThrow } from './use-products-query';

export const useSelectUpgradeDecoderOrThrow = () => {
  const { upgradeDecoder } = useProductsResponseQueryStateOrThrow();

  if (!upgradeDecoder) {
    throw new Error('Upgradable decoder data must be present');
  }

  return { ...upgradeDecoder };
};
